module.exports = __webpack_public_path__ + "img/3.3f7ab59e.jpg";